import React from 'react';
import {useLoaderData} from '@remix-run/react';

//components
import {Link} from 'components/Link';

//domains
import {loader} from '~/routes/($lang)/collections/$collectionHandle';

export default function CollectionBreadcrumb() {
  const {translation, collectionBreadcrumb} = useLoaderData<typeof loader>();

  return (
    <div className="z-10 w-screen bg-white lg:relative lg:left-0 lg:w-full lg:translate-x-0">
      <div className="px-5 lg:px-0">
        <nav className="text-sm md:text-mdflex flex-wrap items-center lg:mb-[34px]">
          <Link
            to="/"
            className="transition-colors duration-200 ease-out hover:text-hk-orange uppercase"
          >
            {translation?.home ?? 'Home'}
          </Link>
          {collectionBreadcrumb &&
            collectionBreadcrumb.map((c) => (
              <span key={`${c.id}-separator`}>
                <span className="mx-2 inline-block">/</span>
                <Link
                  to={`/collections/${c.handle}`}
                  className="transition-colors duration-200 ease-out hover:text-hk-orange uppercase"
                >
                  {c.title}
                </Link>
              </span>
            ))}
        </nav>
      </div>
      <div className="lg:col-span-6"></div>
    </div>
  );
}
